import { Button } from '@/components/ui/button'
import { Typography } from '@/components/ui/typography'
import { MUTED_TEXT } from '@/features/deal-review/review-tones'

export interface BatchFailurePanelProps {
  failures: { label: string; message: string }[]
  sent: number
  duplicates: number
  /** Omitted for people who cannot send: the panel is read-only. */
  onRetry?: () => void
  retrying: boolean
}

export function BatchFailurePanel({
  failures,
  sent,
  duplicates,
  onRetry,
  retrying,
}: BatchFailurePanelProps) {
  const failed = failures.length
  const summary = `${sent} sent. ${failed} not sent.${
    duplicates > 0 ? ` ${duplicates} set aside as duplicates.` : ''
  }`

  return (
    <div
      role="status"
      className="flex flex-col gap-1.5 rounded-md border border-destructive/20 bg-destructive/[0.04] px-3 py-2"
    >
      <div className="flex flex-wrap items-center gap-3">
        <Typography as="span" variant="body-sm" className="text-primary">
          {summary}
        </Typography>
        {onRetry && (
          <Button
            type="button"
            variant="outline"
            size="sm"
            disabled={retrying}
            aria-busy={retrying}
            onClick={onRetry}
          >
            {failed === 1 ? 'Retry that one' : `Retry those ${failed}`}
          </Button>
        )}
      </div>

      <ul className="flex flex-col gap-0.5">
        {failures.map((failure, index) => (
          <li key={`${failure.label}-${index}`}>
            <Typography as="span" variant="body-sm" className="text-primary">
              {failure.label}
            </Typography>{' '}
            <Typography as="span" variant="body-sm" className={MUTED_TEXT}>
              {failure.message}
            </Typography>
          </li>
        ))}
      </ul>
    </div>
  )
}
